import { useIntl } from 'react-intl';
import React, { useMemo } from 'react';
import { messages } from '../messages';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { getAaChange, getNcChange } from '../observationUtils';
import { Tooltip } from '@lifeomic/chroma-react/components/Tooltip';
import { getTestProps } from '../../../../../../util/testProps';

export const shortVariantTestIds = {
  gene: 'shortVariant-gene',
  aaChange: 'shortVariant-aaChange',
  ncChange: 'shortVariant-ncChange',
};

export interface ShortVariantProps {
  gene: string;
  observation: fhir.Observation;
}

export const ShortVariant = (props: ShortVariantProps) => {
  const { formatMessage } = useIntl();
  const { gene, observation } = props;

  const aaChange = useMemo(() => getAaChange(observation), [observation]);
  const ncChange = useMemo(() => getNcChange(observation), [observation]);

  return (
    <>
      {gene && (
        <Tooltip title={formatMessage(messages.targetGene)}>
          <Text size="subbody" {...getTestProps(shortVariantTestIds.gene)}>
            {gene}
          </Text>
        </Tooltip>
      )}
      {aaChange && (
        <Tooltip title={formatMessage(messages.aaChange)}>
          <Text size="subbody" {...getTestProps(shortVariantTestIds.aaChange)}>
            {aaChange}
          </Text>
        </Tooltip>
      )}
      {ncChange && (
        <Tooltip title={formatMessage(messages.ncChange)}>
          <Text size="subbody" {...getTestProps(shortVariantTestIds.ncChange)}>
            {ncChange}
          </Text>
        </Tooltip>
      )}
    </>
  );
};
